import * as Sentry from '@sentry/browser'

export function captureException(error: unknown) {
  Sentry.captureException(error)
}
